import { render, staticRenderFns } from "./EditUserInterviews.vue?vue&type=template&id=96fa5420&scoped=true"
import script from "./EditUserInterviews.vue?vue&type=script&lang=js"
export * from "./EditUserInterviews.vue?vue&type=script&lang=js"
import style0 from "./EditUserInterviews.vue?vue&type=style&index=0&id=96fa5420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fa5420",
  null
  
)

export default component.exports